import React, { useState } from "react";
import { Box, Container, Tab, Typography, Grid } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import HeaderHelpPage from "../../components/HeaderHelpPage";
import TriggerManual from "./triggerManual";
import PatchDataManual from "./patchDataManual";
import { withStyles } from "@mui/styles";
import { COLORS } from "../../utils/colors";

const CustomTabList = withStyles(() => ({
  indicator: {
    backgroundColor: COLORS.OXYGEN7_PURPLE
  },
  flexContainer: {
    "& button:focus": {
      outline: "none"
    },
    "& button:is(.Mui-selected)": {
      color: COLORS.OXYGEN7_PURPLE
    }
  },
}))(TabList);

const PaynowPipelineManual = () => {
  const [value, setValue] = useState("ingestor gateway");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Container>
      <HeaderHelpPage title="Payout pipeline manual" />
      <Box>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <CustomTabList onChange={handleChange}>
              <Tab label="Ingestor gateway 2" value="ingestor gateway" />
              <Tab label="Ingestor gateway 3" value="ingestor gateway_3" />
              <Tab label="Ingestor acquirer" value="ingestor acquirer" />
              <Tab label="Reconciliation" value="reconciliation" />
              <Tab label="Settlement" value="settlement" />
              <Tab label="Reports (New)" value="reports_new" />
              <Tab label="Patch Data" value="patch_data" />
            </CustomTabList>
          </Box>
          <TabPanel value="ingestor gateway">
            <TriggerManual
              title={value}
              url="/payout/ingestor/trigger_manual/"
            />
          </TabPanel>

          <TabPanel value="ingestor gateway_3">
            <TriggerManual
              title={value}
              url="/payout/ingestor/trigger_manual_gw3/"
            />
          </TabPanel>

          <TabPanel value="ingestor acquirer">
            <TriggerManual
              title={value}
              url="/payout/ingestor/trigger_acquirer_manual/"
            />
          </TabPanel>

          <TabPanel value="reconciliation">
            <TriggerManual
              title={value}
              url="/payout/reconciliation/trigger_manual/"
            />
          </TabPanel>

          <TabPanel value="settlement">
            <TriggerManual
              title={value}
              url="/payout/settlement/trigger_manual/"
            />
          </TabPanel>

          <TabPanel value="reports_new">
            <Grid container rowSpacing={4} columnSpacing={2}>
              <Grid item md={6} xs={6}>
                <Typography variant="h4" sx={{ mb: 2, fontWeight: 600 }}>Internal Report</Typography>
                <TriggerManual
                  title="report"
                  url="/payout/report/trigger_manual/"
                  isConsolidated={true}
                />
              </Grid>
              <Grid item md={6} xs={6}>
                <Typography variant="h4" sx={{ mb: 2, fontWeight: 600 }}>Bank Report</Typography>
                <TriggerManual
                  title="bank report"
                  url="/payout/report/trigger_manual_bank_report/"
                  isConsolidated={true}
                />
              </Grid>
              <Grid item md={6} xs={6}>
                <Typography variant="h4" sx={{ mb: 2, fontWeight: 600 }}>Merchant Report</Typography>
                <TriggerManual
                  title="merchant report"
                  url="/payout/report/trigger_manual_merchant_report/"
                  isConsolidated={true}
                />
              </Grid>
              <Grid item md={6} xs={6}>
                <Typography variant="h4" sx={{ mb: 2, fontWeight: 600 }}>Monthly Report</Typography>
                <TriggerManual
                  title="monthly report"
                  url="/payout/report/trigger_manual_monthly_report/"
                  isConsolidated={true}
                />
              </Grid>
            </Grid>
          </TabPanel>

          <TabPanel value="patch_data">
            <Grid container rowSpacing={4} columnSpacing={2}>
              <Grid item md={6} xs={6}>
                <PatchDataManual />
              </Grid>
            </Grid>
          </TabPanel>
        </TabContext>
      </Box>
    </Container>
  );
};

export default PaynowPipelineManual;
